module.exports = "<agm-map #mapContainer (mapReady)=\"onMapReady($event)\" [latitude]=\"options.center.lat\" [longitude]=\"options.center.lng\" [zoom]=\"options.zoom\">\n      </agm-map>\n"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/leaflet-map/leaflet-map.component.html
// module id = ../../../../../src/app/leaflet-map/leaflet-map.component.html
// module chunks = 0